import {createContext} from "react"

const RefreshContext=createContext({})

export default RefreshContext